'use client';

import { ApolloProvider } from '@apollo/client/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { getClient } from '../client';

const ApolloWrapper = ({ children, token }: { children: React.ReactNode; token: string }) => {
  const client = getClient(token);
  const queryClient = new QueryClient();

  return (
    <ApolloProvider client={client}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </ApolloProvider>
  );
};

export { ApolloWrapper };
